module.exports = __webpack_public_path__ + "img/emptySchedule.107d2374.png";